import dayjs from 'dayjs';

const convertFilter = formData => {
  const { couponId, from, itemsOnPage, page, to, type, userId, status, username } = formData;

  const count = itemsOnPage.find(i => i.active)?.value ?? 10;

  const activeType = type.find(i => i.active)?.value;
  const activeStatus = status.find(i => i.active)?.value;

  return {
    user_id: userId || undefined,
    created_at__gte: dayjs(from).format('YYYY-MM-DDTHH:mm:ss') || undefined,
    created_at__lte: dayjs(to).format('YYYY-MM-DDTHH:mm:ss') || undefined,
    coupon_id: couponId || undefined,
    type: activeType === 'all' ? undefined : activeType,
    status: activeStatus === 'all' ? undefined : activeStatus,
    count,
    page,
    tz: -3,
    username,
  };
};

export default convertFilter;
